import React, { useContext, useRef } from 'react'
import classnames from 'classnames'
import { StickyWrapper } from '@/common/sticky'

import { CategoryItemType } from '../../types'
import { CategoryListContext } from '../../context'

import styles from './index.module.less'
import { LangEum } from '@/constant'

interface Props {
  dataSource: CategoryItemType[]
  activeKey: number
}

function Item(props: { data: CategoryItemType; isActive: boolean }) {
  const { data, isActive } = props
  const { onCategoryChange, lang } = useContext(CategoryListContext)
  return (
    <div
      onClick={() => {
        onCategoryChange(data.key)
      }}
      className={classnames({
        [styles['item-wapper']]: true,
        [styles['item_active']]: isActive,
        [styles['item-wapper-en']]: lang === LangEum.en,
      })}
    >
      {data.title}
    </div>
  )
}

function List(props: { dataSource: CategoryItemType[]; activeKey: number }) {
  return (
    <div className={styles['list-wrapper']}>
      {props.dataSource.map((ele) => {
        return <Item isActive={ele.key === props.activeKey} key={ele.key} data={ele} />
      })}
    </div>
  )
}

function CategoryList(props: Props) {
  const { dataSource, activeKey } = props
  const ref = useRef(null)
  return (
    <div className={styles['category-list-wrapper']}>
      <div className={styles['border-radio-placeholder']} />
      <StickyWrapper>
        {({ style }) => {
          return (
            <div className={styles['type-list-content-wrapper']} style={style}>
              <div className={styles['type-list-content']} ref={ref}>
                <List activeKey={activeKey} dataSource={dataSource} />
              </div>
            </div>
          )
        }}
      </StickyWrapper>
    </div>
  )
}

export default React.memo(CategoryList)
